import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaBySolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.86 23h16.28A2.86 2.86 0 0 0 23 20.14V3.86A2.86 2.86 0 0 0 20.14 1H3.86A2.86 2.86 0 0 0 1 3.86v16.28A2.86 2.86 0 0 0 3.86 23M18.033 8.768a4.56 4.56 0 0 1-.301 4.09 4.6 4.6 0 0 1-1.756 1.68l2.404 3.512h-3.3l-2.027-2.97H9.36v2.97H6.28V5.95h7.535a4.56 4.56 0 0 1 4.218 2.818M9.36 12h4.455c.817 0 1.485-.668 1.485-1.485s-.668-1.485-1.485-1.485H9.36z"
            fill="currentColor"
        />
    </svg>
));
RabotaBySolidSize24Glyph.displayName = 'RabotaBySolidSize24Glyph';
